import { fetch } from '@financial-tool/fetch';
import { Expense } from '../types/expense';

export default function updateExpenseAPI({ id, ...expenseWithoutId }: Partial<Expense>) {
  return fetch.put<Expense>(`/expenses/${id}`, expenseWithoutId);
}
